if (!customElements.get('tccs-mobile-buybar')) {
  customElements.define(
    'tccs-mobile-buybar',
    class TccsMobileBuybar extends HTMLElement {
      connectedCallback() {
        this.primaryButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        this.priceSource = document.getElementById(`price-${this.dataset.section}`);
        this.quantityInput = document.getElementById(`Quantity-${this.dataset.section}`);
        this.mobileButton = this.querySelector('[data-tccs-mobile-submit]');
        this.mobilePrice = this.querySelector('[data-tccs-mobile-price]');
        this.mobileOrderQuantity = this.querySelector('[data-tccs-mobile-order-quantity]');

        if (!this.primaryButton || !this.mobileButton) return;

        this.onScroll = this.onScroll.bind(this);
        this.onQuantityChange = this.syncOrderQuantity.bind(this);
        this.onVariantChange = this.handleVariantChange.bind(this);
        this.onSubmit = () => this.primaryButton.click();
        this.mobileButton.addEventListener('click', this.onSubmit);
        this.quantityInput?.addEventListener('input', this.onQuantityChange);
        this.quantityInput?.addEventListener('change', this.onQuantityChange);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);

        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.primaryButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });

        if (this.priceSource) {
          this.priceObserver = new MutationObserver(() => this.syncPrice());
          this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
        }

        this.syncButton();
        this.syncPrice();
        this.syncOrderQuantity();
        this.onScroll();
      }

      disconnectedCallback() {
        this.mobileButton?.removeEventListener('click', this.onSubmit);
        this.quantityInput?.removeEventListener('input', this.onQuantityChange);
        this.quantityInput?.removeEventListener('change', this.onQuantityChange);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.variantChangeUnsubscriber?.();
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
      }

      handleVariantChange({ data: { sectionId, html } }) {
        if (String(sectionId) !== String(this.dataset.section)) return;

        const source = html.querySelector('tccs-mobile-buybar');
        if (source) {
          this.syncTextNode('[data-tccs-mobile-part]', source);
          this.syncTextNode('[data-tccs-mobile-package]', source);
        }

        this.syncButton();
        this.syncPrice();
        this.syncOrderQuantity();
      }

      syncTextNode(selector, source) {
        const sourceNode = source.querySelector(selector);
        const destinationNode = this.querySelector(selector);

        if (sourceNode && destinationNode) {
          destinationNode.textContent = sourceNode.textContent;
          destinationNode.hidden = false;
        } else if (destinationNode) {
          destinationNode.hidden = true;
        }
      }

      syncButton() {
        this.mobileButton.disabled =
          this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';
        const label = this.primaryButton.querySelector('span')?.textContent?.trim();
        if (label) this.mobileButton.textContent = label;
      }

      syncPrice() {
        const price = this.priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent?.trim();
        if (price) this.mobilePrice.textContent = price;
      }

      syncOrderQuantity() {
        if (!this.mobileOrderQuantity) return;
        const quantity = Number.parseInt(this.quantityInput?.value, 10) || 1;
        this.mobileOrderQuantity.textContent = `Order qty ${quantity}`;
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          const passedPrimaryButton = this.primaryButton.getBoundingClientRect().bottom < 0;
          this.classList.toggle('is-active', window.innerWidth <= 749 && passedPrimaryButton);
          this.frame = null;
        });
      }
    }
  );
}
